export { default as DOMNavigator } from './dom-navigator.js';
